import { Switch, SwitchProps, styled } from '@mui/material';
import React from 'react';

import { colors } from '../theme/theme';

interface CustomSwitchProps extends Omit<SwitchProps, 'color'> {
    activeColor?: string;
    inactiveColor?: string;
    thumbColor?: string;
}

const StyledSwitch = styled(Switch)(({ theme }) => ({
    height: 18,
    width: 36,
    padding: 0,
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 2,
        transitionDuration: '300ms',
        '&.Mui-checked': {
            left: -3,
            transform: 'translateX(20px)',
            color: colors.fullWhite,
            '& + .MuiSwitch-track': {
                opacity: 1,
                border: 0,
            },
        },
        '&.Mui-disabled': {
            '& + .MuiSwitch-track': {
                opacity: 0.5,
            },
        },
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 14,
        height: 14,
        color: colors.fullWhite,
        boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.2)',
    },
    '& .MuiSwitch-track': {
        borderRadius: 24 / 2,
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 300,
        }),
    },
}));

export const CustomSwitch: React.FC<CustomSwitchProps> = ({
    activeColor,
    inactiveColor,
    thumbColor,
    checked,
    onChange,
    ...props
}) => {
    return (
        <StyledSwitch
            className="switchWrapper"
            {...props}
            checked={checked}
            onChange={onChange}
            tabIndex={0}
            inputProps={{
                'aria-label': 'switch',
            }}
            onKeyDown={event => {
                if (event.key === 'Enter') {
                    event.preventDefault();

                    const syntheticEvent = {
                        target: {
                            checked: !checked,
                        },
                    } as React.ChangeEvent<HTMLInputElement>;

                    onChange?.(syntheticEvent, !checked);
                }
            }}
            sx={{
                '& .MuiSwitch-switchBase.Mui-checked': {
                    '& + .MuiSwitch-track': {
                        backgroundColor: activeColor || colors.successPreset[10],
                    },
                },
                '& .MuiSwitch-track': {
                    backgroundColor: checked
                        ? activeColor || colors.successPreset[10]
                        : inactiveColor || colors.greyPreset[30],
                },
                '& .MuiSwitch-thumb': {
                    color: thumbColor || colors.fullWhite,
                },
                ...props.sx,
            }}
        />
    );
};
